/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { Button, Col, Form, Input, Row, Select, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { CaretDownOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { getPortalDetails } from "api/services/bannerDetails.api";
import { associateProduct, getrawlingsartificonfigurationdata } from "api/services/product.api";
import { IGetAssociatedProduct } from "interfaces/ClientInterface/IProduct";
import { getLookupConfiguration } from "api/services/getLookupConfiguration.api";
import { notificationController } from "components/Common/Notification/Notification";
import { setProductCustomizationDetails } from "store/slices/productCustomizationSlice";
import { ROUTES_PATH } from "routes/Routes.Constant";
import { Artifisettings } from "api/IProduct";
import { setSelectedProductRedux } from "store/slices/product.slice";
import { setLookup } from "store/slices/lookup.slice";
import { useAppSelector } from "hooks/reduxHooks";
import Heading from "components/Common/Heading/Heading";
import ArtifiIntegration from "components/Product/ArtifiIntegration";
import "./LookupConfig.scss";

const LookupConfig: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [portalId, setPortalId] = useState<number>(0);
  const [showArtifi, setshowArtifi] = useState<boolean>(false);
  const [isSubmitLookup, setSubmitLookup] = useState<boolean>(false);
  const [configurationId, setConfigurationId] = useState<any>();
  const [products, setProducts] = useState<IGetAssociatedProduct[]>([]);
  const [artifConfigurations, setArtifiConfigurations] = useState<Artifisettings | undefined>();
  const lockerDetails: any = useAppSelector((state) => state.landingPage.lockerPortalDetails);

  const portalDetails = () => {
    getPortalDetails()
      .then((response) => {
        const portalDetails = response?.data?.rawlingsMyLockerPortalDetailsModel;
        const { PortalId, PublishCatalogId } = portalDetails || {};
        setPortalId(PortalId);
        if (PortalId && PublishCatalogId) {
          associateProduct(PortalId, PublishCatalogId)
            .then((response) => {
              const responseData = response?.data?.PublishProducts.sort(
                (a: any, b: any) => a?.DisplayOrder - b?.DisplayOrder
              );
              setProducts(responseData);
            })
            .catch((error) => {
              throw error;
            });
        }
      })
      .catch((error) => {
        throw error;
      });
  };

  const getCode = (code: string): string[] => {
    if (code === "Helmet") {
      return ["helmets", "rawlings"];
    }
    if (code === "RawlingsGlove") {
      return ["gloves", "rawlings"];
    }
    if (code === "EastonGlove") {
      return ["gloves", "easton"];
    }
    if (code === "EastonHelmet") {
      return ["helmets", "easton"];
    }
    if (code === "WoodBat") {
      return ["woodbats", "rawlings"];
    }
    return [];
  };

  const openConfigurationWindow = async (
    [product, domain]: string[],
    customProduct: any
  ): Promise<void> => {
    // localStorage.setItem("isRawlingUpdate", "true");
    const guid = JSON.parse(customProduct?.ProductCustomizationJson)?.guid;
    const configUrl = process.env.REACT_APP_THIRD_PARTY_CONFIGURATION;
    const openConfig = configUrl?.replace("<product>", product).replace("<domain>", domain);
    window.open(`${openConfig}/design/${customProduct?.DesignId}?guid=${guid}`, "_self");
  };

  const onSubmitLookup = async () => {
    ReactGA.event({
      category: "lookup_clicked",
      action: "lookup button clicked",
      label: "lookup button clicked",
    });
    setSubmitLookup(true);
    const selectedProductName = form.getFieldValue("selectBuilder");
    const selectedProduct = products.find((product) => product.Name === selectedProductName);
    const configurationId = form.getFieldValue("configurationId");
    setConfigurationId(configurationId);
    if (selectedProduct && configurationId) {
      getLookupConfiguration(selectedProduct?.SKU, configurationId)
        .then((response) => {
          if (response.status === 200 && response?.data && response?.data?.ProductName !== null) {
            localStorage.setItem("SKU", selectedProduct?.SKU);
            if (response?.data?.DesignType === "Artifi") {
              dispatch(setProductCustomizationDetails(response.data));
              dispatch(setSelectedProductRedux(response.data));
              dispatch(setLookup({ fromLookup: true } as any));
              setshowArtifi(true);
            } else if (response?.data?.DesignType === "Rawlings") {
              associateProduct(
                lockerDetails?.lockerPortalDetails?.PortalId,
                lockerDetails?.lockerPortalDetails?.PublishCatalogId
              )
                .then((associatedProductsList: any) => {
                  setSubmitLookup(false);
                  if (
                    associatedProductsList &&
                    associatedProductsList?.data &&
                    associatedProductsList?.data?.PublishProducts
                  ) {
                    const configuratorProduct = associatedProductsList?.data?.PublishProducts.find(
                      (item: any) => item.SKU === response?.data?.SKU
                    );

                    const attributes = configuratorProduct?.Attributes.filter(
                      (attribute: any) => attribute?.AttributeCode === "ConfigurationType"
                    );

                    const configuratorType = attributes[0]?.SelectValues[0]?.Code;

                    openConfigurationWindow(getCode(configuratorType), response?.data);
                  }
                })
                .catch((error) => {
                  setSubmitLookup(false);
                  throw error;
                });
            }
          } else {
            setSubmitLookup(false);
            const errorMessage = "This configuration does not exist.";
            notificationController.error({
              message: errorMessage,
            });
          }
        })
        .catch((error) => {
          setSubmitLookup(false);
          throw error;
        });
    }
  };

  const handleCancel = () => {
    navigate(ROUTES_PATH.HOMEPAGE);
  };

  useEffect(() => {
    portalDetails();
  }, []);

  useEffect(() => {
    if (portalId != 0) {
      getrawlingsartificonfigurationdata(portalId || 0)
        .then((res) => {
          setArtifiConfigurations(res?.data?.AIZnodePortalSetting);
        })
        .catch((err) => {
          throw err;
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portalId]);

  return (
    <div className="page-content-wrapper p-30">
      <Row gutter={15} className="lookup-form-container">
        <Col xs={24} md={12} xxl={6} lg={6} xl={6}>
          <Heading titleText="Configuration Lookup" titleClass="global-form-heading" />
          <div className="form-wrapper">
            <Form
              form={form}
              layout="vertical"
              name="lookup-config"
              initialValues={{ remember: true }}
              autoComplete="off"
              onFinish={onSubmitLookup}
            >
              <Form.Item
                label={
                  <span className="wrapper">
                    Select Builder <span className="text-danger">*</span>
                  </span>
                }
                name="selectBuilder"
                rules={[{ required: true, message: "Please select builder" }]}
                className="input-label"
              >
                <Select
                  showSearch
                  suffixIcon={
                    <CaretDownOutlined
                      style={{ pointerEvents: "none", color: "rgba(0, 0, 0, 0.88)" }}
                    />
                  }
                  optionFilterProp="children"
                  className="builder-dropdown"
                  onChange={(value) => localStorage.setItem("selectedProduct", value)}
                >
                  {products.map((product, index) => (
                    <Select.Option key={index} value={product?.Name}>
                      {product?.Name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label={
                  <span className="wrapper">
                    Configuration ID <span className="text-danger">*</span>
                  </span>
                }
                name="configurationId"
                rules={[{ required: true, message: "Configuration ID is required" }]}
              >
                <Input className="form-input" />
              </Form.Item>
              <Form.Item>
                <Space size={"middle"}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="lookup-btn"
                    loading={isSubmitLookup}
                  >
                    Lookup
                  </Button>
                  <Button className="cancel-btn" onClick={handleCancel}>
                    Cancel
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
      {showArtifi && (
        <ArtifiIntegration
          artifConfigurations={artifConfigurations}
          setShowComponent={setshowArtifi}
          ReorderMode={false}
          lookupMode={true}
          configurationId={configurationId}
        />
      )}
    </div>
  );
};

export default LookupConfig;
